var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBodyBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2289,
    height: 5366,
    viewBox: "0 0 2289 5366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10575 2252.83C2.92701 2251.82 2.38542 2250.7 2.5 2249.49C3.39524 2240.02 3.88446 2241.85 4.10575 2252.83C43.5373 2286.82 795.966 2207.52 1548.27 1746.81C1968.79 1489.29 2035.82 1413.96 2210 1421.5L2210 2002.5C1558.32 2428.06 2.49957 2816.49 2.49959 2600.99C2.4996 2434.35 4.86034 2290.3 4.10575 2252.83Z",
    fill: "#FED36A",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2184.7 3132.5C1093.81 4011.5 2.92798 3398 2.92798 3398L2.92787 4292C884.92 4493.5 1593.19 4187 2184.7 3748L2184.7 3132.5Z",
    fill: "#D4EEEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00009 2092.4C1637.59 2936.5 2112.25 2266.5 2112.25 3050L2112.25 3408C1748.69 2913.48 1084.96 3090.19 4.00227 2751.87L4.00009 2092.4Z",
    fill: "#F09594",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.566967 4225.81C719.701 3806.47 2238.08 4303.53 2288.62 4963.76L2231.32 5365.5C1653.87 4177.03 0.567246 4610.81 0.567246 4610.81L0.566967 4225.81Z",
    fill: "#EC9783",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 895.293C26 662.217 1777.65 579.69 2052 579.69V0H1039H26V895.293Z",
    fill: "#227AD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyBg);
export default __webpack_public_path__ + "static/media/body-bg.3b3bf27dcb800f6998d094b5318f69bf.svg";
export { ForwardRef as ReactComponent };